import step1 from '@src/assets/step1.png';
import step2 from '@src/assets/step2.png';
import step3 from '@src/assets/step3.png';
import step4 from '@src/assets/step4.png';
import step5 from '@src/assets/step5.png';
import step6 from '@src/assets/step6.png';
import step7 from '@src/assets/step7.png';
import stepEn1 from '@src/assets/stepEn1.png';
import stepEn2 from '@src/assets/stepEn2.png';
import stepEn3 from '@src/assets/stepEn3.png';
import stepEn4 from '@src/assets/stepEn4.png';
import stepEn5 from '@src/assets/stepEn5.png';
import stepEn6 from '@src/assets/stepEn6.png';
import stepEn7 from '@src/assets/stepEn7.png';

export const stepList = [
    {
        title: 'Step. 1',
        img: step1,
        imgEn: stepEn1,
        text: 'step1',
    },
    {
        title: 'Step. 2',
        img: step2,
        imgEn: stepEn2,
        text: 'step2',
    },
    {
        title: 'Step. 3',
        img: step3,
        imgEn: stepEn3,
        text: 'step3',
    },
    {
        title: 'Step. 4',
        img: step4,
        imgEn: stepEn4,
        text: 'step4',
    },
    {
        title: 'Step. 5',
        img: step5,
        imgEn: stepEn5,
        text: 'step5',
    },
    {
        title: 'Step. 6',
        img: step6,
        imgEn: stepEn6,
        text: 'step6',
    },
    {
        title: 'Step. 7',
        img: step7,
        imgEn: stepEn7,
        text: 'step7',
    },
];
